module.exports = __webpack_public_path__ + "img/pig.9654bddc.svg";